import {omit, isEqual} from 'helpers';

export function identity(state = {}, action) {

  switch (action.type) {
    case 'SERVER_IDENTITY_LOADED':
      const fetched = omit(action.data, 'serverTime');
      return isEqual(state, fetched) ? state : fetched;

    case 'IDENTITY_UPDATE':
      return {
        ...state,
        [action.name]: action.data
      }

    default:
      return state;
  }

}
